import React from 'react';
import {
  FaPrint,
  FaDownload,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaLinkedin,
  FaGithub,
  FaBriefcase,
  FaGraduationCap,
  FaCertificate,
  FaTools,
  FaProjectDiagram,
  FaLanguage
} from 'react-icons/fa';

function CV() {

  const handlePrint = () => {
    window.print();
  };

  return (
    <div style={{ background: '#071325', minHeight: '100vh', padding: '40px 20px', color: '#ffffff' }}>
      <div className="cv-container" style={{ maxWidth: '960px', margin: '0 auto' }}>

        {/* TOP BAR ACTIONS: PRINT & DOWNLOAD */}
        <div className="no-print" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px',
          marginBottom: '24px',
          background: 'rgba(16, 37, 66, 0.7)',
          padding: '16px 24px',
          borderRadius: '16px',
          border: '1px solid rgba(69, 170, 242, 0.3)'
        }}>
          <div>
            <span className="badge badge-gold">📄 ATS-Formatted Resume</span>
          </div>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={handlePrint}
              className="btn-primary"
              style={{ padding: '8px 18px', fontSize: '0.88rem' }}
            >
              <FaPrint /> Print / Save as PDF
            </button>
            <a
              href="/skills_deck.html"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary"
              style={{ padding: '8px 16px', fontSize: '0.88rem' }}
            >
              <FaDownload /> Presentation Deck
            </a>
          </div>
        </div>

        {/* EXECUTIVE HEADER CARD */}
        <header className="cv-card glass-card" style={{ padding: '32px', marginBottom: '30px' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            flexWrap: 'wrap'
          }}>
            <img
              src="/dejicvuse.png"
              alt="Adedeji Babalola"
              style={{
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                objectFit: 'cover',
                border: '3px solid #45aaf2',
                boxShadow: '0 6px 20px rgba(69, 170, 242, 0.3)'
              }}
            />
            <div style={{ flex: 1 }}>
              <h1 style={{ margin: '0 0 6px 0', fontSize: '2.4rem', color: '#ffffff' }}>Adedeji Babalola</h1>
              <h3 style={{ margin: '0 0 12px 0', color: '#45aaf2', fontSize: '1.2rem', fontWeight: '600' }}>
                Cloud &amp; Infrastructure Engineer • Microsoft Azure • Linux • Kubernetes / OpenShift
              </h3>
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '16px',
                fontSize: '0.9rem',
                color: '#cbd5e1'
              }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <FaMapMarkerAlt color="#45aaf2" /> Vantaa, Finland
                </span>
                <a href="mailto:daygme@gmail.com" style={{ color: '#45aaf2', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <FaEnvelope /> daygme@gmail.com
                </a>
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <FaPhone color="#2ecc71" /> +358 46 900 0000
                </span>
                <a href="https://github.com/dejoo10" target="_blank" rel="noopener noreferrer" style={{ color: '#45aaf2', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <FaGithub /> GitHub
                </a>
                <a href="https://linkedin.com/in/adedeji-babalola-9a71aa30" target="_blank" rel="noopener noreferrer" style={{ color: '#45aaf2', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <FaLinkedin /> LinkedIn Profile
                </a>
              </div>
            </div>
          </div>
        </header>

        {/* QUICK JUMP NAV PILLS */}
        <nav className="no-print" style={{
          display: 'flex',
          gap: '10px',
          marginBottom: '30px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          {[
            { id: 'summary', label: 'Executive Summary' },
            { id: 'skills', label: 'Technical Skills' },
            { id: 'work-history', label: 'Work Experience' },
            { id: 'projects', label: 'Technical Projects' },
            { id: 'education', label: 'Education' },
            { id: 'certifications', label: 'Certifications' },
            { id: 'languages', label: 'Languages' },
          ].map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              style={{
                textDecoration: 'none',
                color: '#ffffff',
                background: 'rgba(16, 37, 66, 0.6)',
                border: '1px solid rgba(69, 170, 242, 0.3)',
                padding: '8px 18px',
                borderRadius: '20px',
                fontSize: '0.88rem',
                fontWeight: '600',
                transition: 'all 0.2s ease'
              }}
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* 1. PROFESSIONAL SUMMARY */}
        <section id="summary" className="cv-card glass-card" style={{ padding: '28px', marginBottom: '28px' }}>
          <h2 style={{ color: '#45aaf2', borderBottom: '2px solid rgba(69, 170, 242, 0.3)', paddingBottom: '8px', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaBriefcase /> PROFESSIONAL SUMMARY
          </h2>
          <p style={{ color: '#cbd5e1', fontSize: '1rem', lineHeight: '1.7', margin: 0 }}>
            Cloud &amp; Infrastructure Engineer with professional experience managing Microsoft Azure infrastructure for an AI-based legal technology startup and hands-on experience building Linux, Kubernetes/OpenShift, and virtualization environments. Strong foundation in cloud operations, networking, container platforms, storage, and infrastructure services including DNS, DHCP, HAProxy, and NFS. Holds a BEng in Information Technology with an MSc in Circular Economy.
          </p>
        </section>

        {/* 2. CORE SKILLS MATRIX */}
        <section id="skills" className="cv-card glass-card" style={{ padding: '28px', marginBottom: '28px' }}>
          <h2 style={{ color: '#45aaf2', borderBottom: '2px solid rgba(69, 170, 242, 0.3)', borderBottomStyle: 'solid', paddingBottom: '8px', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaTools /> CORE TECHNICAL COMPETENCIES
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '20px'
          }}>
            <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '16px', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
              <h4 style={{ color: '#00d2d3', marginBottom: '8px', fontSize: '1rem' }}>Cloud &amp; Infrastructure</h4>
              <p style={{ color: '#cbd5e1', fontSize: '0.92rem', margin: 0, lineHeight: '1.5' }}>
                AWS, Microsoft Azure, OpenShift, Kubernetes, Docker, Proxmox, TrueNAS
              </p>
            </div>
            <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '16px', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
              <h4 style={{ color: '#00d2d3', marginBottom: '8px', fontSize: '1rem' }}>Networks &amp; Services</h4>
              <p style={{ color: '#cbd5e1', fontSize: '0.92rem', margin: 0, lineHeight: '1.5' }}>
                CCNA, Switching, Routing, DNS, DHCP, HAProxy, VLANs, NFS
              </p>
            </div>
            <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '16px', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
              <h4 style={{ color: '#00d2d3', marginBottom: '8px', fontSize: '1rem' }}>DevOps &amp; Automation</h4>
              <p style={{ color: '#cbd5e1', fontSize: '0.92rem', margin: 0, lineHeight: '1.5' }}>
                Linux, CI/CD pipelines, GitHub, Virtualization, Python, Bash scripting, SQL
              </p>
            </div>
            <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '16px', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
              <h4 style={{ color: '#00d2d3', marginBottom: '8px', fontSize: '1rem' }}>Security &amp; Tools</h4>
              <p style={{ color: '#cbd5e1', fontSize: '0.92rem', margin: 0, lineHeight: '1.5' }}>
                Cisco CyberOps, Infrastructure Security, Access Controls, Technical Documentation
              </p>
            </div>
          </div>
        </section>

        {/* 3. WORK HISTORY */}
        <section id="work-history" className="cv-card glass-card" style={{ padding: '28px', marginBottom: '28px' }}>
          <h2 style={{ color: '#45aaf2', borderBottom: '2px solid rgba(69, 170, 242, 0.3)', paddingBottom: '8px', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaBriefcase /> WORK EXPERIENCE
          </h2>

          {/* Job 1: Cloud Engineer | Justice4.0 */}
          <div style={{ marginBottom: '26px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'baseline' }}>
              <h3 style={{ margin: '0 0 4px 0', color: '#ffffff', fontSize: '1.2rem' }}>
                Cloud Engineer <span style={{ color: '#45aaf2' }}>|</span> Justice4.0
              </h3>
              <span style={{ color: '#2ecc71', fontWeight: '600', fontSize: '0.9rem' }}>Nov 2024 – Jul 2025</span>
            </div>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', margin: '0 0 10px 0' }}>Vantaa, Finland • AI Legal Technology Platform (Snowlex)</p>
            <ul style={{ color: '#cbd5e1', paddingLeft: '20px', margin: 0, fontSize: '0.93rem', lineHeight: '1.6' }}>
              <li>Managed and optimised Microsoft Azure cloud infrastructure underpinning AI legal platform (Snowlex), upholding 99.9% service availability.</li>
              <li>Monitored multi-environment system performance, availability, and operational health, maintaining strict SLAs and sub-second API latencies.</li>
              <li>Supported deployment, troubleshooting, and continuous maintenance of cloud applications and containerized microservices across staging and production.</li>
              <li>Implemented scalable, cost-efficient cloud architecture, optimizing resource allocation to reduce cloud infrastructure spend by ~18%.</li>
              <li>Strengthened infrastructure security posture through Azure RBAC, access controls, reliability engineering, and detailed technical documentation.</li>
              <li>Collaborated with cross-functional teams in developing and launching the initial landing page and web presence of Snowlex.</li>
            </ul>
          </div>

          {/* Job 2: Customer Care Representative | Tech Mahindra */}
          <div style={{ marginBottom: '26px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'baseline' }}>
              <h3 style={{ margin: '0 0 4px 0', color: '#ffffff', fontSize: '1.2rem' }}>
                Customer Care Representative <span style={{ color: '#45aaf2' }}>|</span> Tech Mahindra
              </h3>
              <span style={{ color: '#94a3b8', fontWeight: '600', fontSize: '0.9rem' }}>Dec 2015 – Aug 2016</span>
            </div>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', margin: '0 0 8px 0' }}>Abeokuta, Nigeria</p>
            <ul style={{ color: '#cbd5e1', paddingLeft: '20px', margin: 0, fontSize: '0.93rem', lineHeight: '1.6' }}>
              <li>Managed high call volumes with exceptional professionalism, active listening, and technical troubleshooting, maintaining a 94%+ customer satisfaction score.</li>
              <li>Streamlined response and handle times by 15% through structured call-handling workflows and accurate first-call resolution.</li>
              <li>Maintained thorough product knowledge to provide precise technical support and logged resolution steps into internal ticketing databases.</li>
            </ul>
          </div>

          {/* Job 3: Customer Support Specialist | Best Solution ICT */}
          <div style={{ marginBottom: '26px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'baseline' }}>
              <h3 style={{ margin: '0 0 4px 0', color: '#ffffff', fontSize: '1.2rem' }}>
                Customer Support Specialist <span style={{ color: '#45aaf2' }}>|</span> Best Solution ICT
              </h3>
              <span style={{ color: '#94a3b8', fontWeight: '600', fontSize: '0.9rem' }}>Jan 2013 – Dec 2015</span>
            </div>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', margin: '0 0 8px 0' }}>Abeokuta, Nigeria</p>
            <ul style={{ color: '#cbd5e1', paddingLeft: '20px', margin: 0, fontSize: '0.93rem', lineHeight: '1.6' }}>
              <li>Provided technical assistance across phone, email, and live chat, resolving complex hardware, OS, and software issues for 500+ client workstations.</li>
              <li>Installed, configured, and hardened operating systems and application software for end-user workstations.</li>
              <li>Collaborated with cross-functional teams to streamline support procedures and elevate service quality standards.</li>
            </ul>
          </div>

          {/* Job 4: Project Manager (Part-Time) | Habruf Nig Ltd */}
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'baseline' }}>
              <h3 style={{ margin: '0 0 4px 0', color: '#ffffff', fontSize: '1.2rem' }}>
                Project Manager (Part-Time) <span style={{ color: '#45aaf2' }}>|</span> Habruf Nig Ltd
              </h3>
              <span style={{ color: '#45aaf2', fontWeight: '600', fontSize: '0.9rem' }}>Jan 2013 – Jul 2015</span>
            </div>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', margin: '0 0 8px 0' }}>Nigeria • Cross-Functional Operations</p>
            <ul style={{ color: '#cbd5e1', paddingLeft: '20px', margin: 0, fontSize: '0.93rem', lineHeight: '1.6' }}>
              <li>Coordinated project activities, delivery timelines, and operational tasks across cross-functional teams, achieving 95%+ on-time milestone delivery.</li>
              <li>Managed stakeholder communications, progress reporting, risk mitigation, and comprehensive project documentation.</li>
            </ul>
          </div>
        </section>

        {/* 4. TECHNICAL PROJECTS */}
        <section id="projects" className="cv-card glass-card" style={{ padding: '28px', marginBottom: '28px' }}>
          <h2 style={{ color: '#45aaf2', borderBottom: '2px solid rgba(69, 170, 242, 0.3)', paddingBottom: '8px', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaProjectDiagram /> TECHNICAL PROJECTS
          </h2>

          {/* Project 1 */}
          <div style={{ marginBottom: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'baseline' }}>
              <h3 style={{ margin: '0 0 6px 0', color: '#ffffff', fontSize: '1.15rem' }}>
                OpenShift Virtualization Infrastructure (BEng Thesis)
              </h3>
            </div>
            <div style={{ display: 'inline-block', background: 'rgba(69, 170, 242, 0.15)', color: '#00d2d3', border: '1px solid rgba(69, 170, 242, 0.3)', borderRadius: '6px', padding: '3px 10px', fontSize: '0.82rem', fontWeight: '600', marginBottom: '8px' }}>
              OpenShift, Kubernetes, KubeVirt, DNS, DHCP, HAProxy, NFS
            </div>
            <ul style={{ color: '#cbd5e1', paddingLeft: '20px', margin: 0, fontSize: '0.93rem', lineHeight: '1.6' }}>
              <li>Designed and deployed bare-metal multi-node OpenShift Container Platform environment from scratch.</li>
              <li>Configured K8s-based virtualization using OpenShift Virtualization operator (KubeVirt); built automated VM pipelines and HAProxy load balancing.</li>
            </ul>
          </div>

          {/* Project 2 */}
          <div style={{ marginBottom: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'baseline' }}>
              <h3 style={{ margin: '0 0 6px 0', color: '#ffffff', fontSize: '1.15rem' }}>
                Proxmox Virtualization Infrastructure (Lab)
              </h3>
            </div>
            <div style={{ display: 'inline-block', background: 'rgba(69, 170, 242, 0.15)', color: '#00d2d3', border: '1px solid rgba(69, 170, 242, 0.3)', borderRadius: '6px', padding: '3px 10px', fontSize: '0.82rem', fontWeight: '600', marginBottom: '8px' }}>
              Proxmox VE, Linux, VLANs, Ceph, NFS
            </div>
            <ul style={{ color: '#cbd5e1', paddingLeft: '20px', margin: 0, fontSize: '0.93rem', lineHeight: '1.6' }}>
              <li>Built 3-node Proxmox VE cluster with High Availability (HA), Ceph distributed storage, and isolated VLAN network segmentation.</li>
              <li>Managed VM and LXC container provisioning, dynamic resource allocation, and cluster health monitoring with 100% test workload uptime.</li>
            </ul>
          </div>

          {/* Project 3 */}
          <div style={{ marginBottom: '24px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'baseline' }}>
              <h3 style={{ margin: '0 0 6px 0', color: '#ffffff', fontSize: '1.15rem' }}>
                TrueNAS Centralised Storage Infrastructure (Lab)
              </h3>
            </div>
            <div style={{ display: 'inline-block', background: 'rgba(69, 170, 242, 0.15)', color: '#00d2d3', border: '1px solid rgba(69, 170, 242, 0.3)', borderRadius: '6px', padding: '3px 10px', fontSize: '0.82rem', fontWeight: '600', marginBottom: '8px' }}>
              TrueNAS, NFS, ZFS Storage
            </div>
            <ul style={{ color: '#cbd5e1', paddingLeft: '20px', margin: 0, fontSize: '0.93rem', lineHeight: '1.6' }}>
              <li>Deployed dedicated TrueNAS storage server providing high-throughput NFS shared storage for virtualization workloads.</li>
              <li>Managed ZFS pools, scheduled snapshots, and automated replication tasks to guarantee data integrity and rapid disaster recovery.</li>
            </ul>
          </div>

          {/* Project 4 */}
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', alignItems: 'baseline' }}>
              <h3 style={{ margin: '0 0 6px 0', color: '#ffffff', fontSize: '1.15rem' }}>
                Eastland Top Tutors Platform (eastlandtoptutors.com)
              </h3>
            </div>
            <ul style={{ color: '#cbd5e1', paddingLeft: '20px', margin: 0, fontSize: '0.93rem', lineHeight: '1.6' }}>
              <li>Developed and deployed full educational platform; managed hosting infrastructure, custom DNS routing, automated SSL/TLS encryption, and 99.9% uptime.</li>
            </ul>
          </div>
        </section>

        {/* 5. EDUCATION */}
        <section id="education" className="cv-card glass-card" style={{ padding: '28px', marginBottom: '28px' }}>
          <h2 style={{ color: '#45aaf2', borderBottom: '2px solid rgba(69, 170, 242, 0.3)', paddingBottom: '8px', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaGraduationCap /> EDUCATION &amp; ACADEMICS
          </h2>

          <div style={{ marginBottom: '18px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
              <h3 style={{ margin: '0 0 2px 0', color: '#ffffff', fontSize: '1.1rem' }}>Bachelor of Science: Information &amp; Communication Technology</h3>
              <span style={{ color: '#45aaf2', fontWeight: '600', fontSize: '0.88rem' }}>June 2026</span>
            </div>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', margin: 0 }}>
              Metropolitan University of Applied Sciences (Metropolia), Helsinki, Finland • <em>Major: Smart IoT Systems</em>
            </p>
          </div>

          <div style={{ marginBottom: '18px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
              <h3 style={{ margin: '0 0 2px 0', color: '#ffffff', fontSize: '1.1rem' }}>Master of Science: Circular Economy</h3>
              <span style={{ color: '#45aaf2', fontWeight: '600', fontSize: '0.88rem' }}>July 2023</span>
            </div>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', margin: 0 }}>
              Lappeenranta-Lahti University of Technology (LUT), Lahti, Finland
            </p>
          </div>

          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
              <h3 style={{ margin: '0 0 2px 0', color: '#ffffff', fontSize: '1.1rem' }}>Bachelor of Science: Physics</h3>
              <span style={{ color: '#45aaf2', fontWeight: '600', fontSize: '0.88rem' }}>Nov 2012</span>
            </div>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', margin: 0 }}>
              University of Ibadan, Ibadan, Nigeria
            </p>
          </div>
        </section>

        {/* 6. CERTIFICATIONS */}
        <section id="certifications" className="cv-card glass-card" style={{ padding: '28px', marginBottom: '28px' }}>
          <h2 style={{ color: '#45aaf2', borderBottom: '2px solid rgba(69, 170, 242, 0.3)', paddingBottom: '8px', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaCertificate /> PROFESSIONAL CERTIFICATIONS
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '12px',
            color: '#cbd5e1',
            fontSize: '0.93rem'
          }}>
            <div>✓ <strong>Red Hat Academy:</strong> Program Learner (2024–2025)</div>
            <div>✓ <strong>AWS Academy:</strong> Cloud Architecting (2024)</div>
            <div>✓ <strong>Cisco:</strong> Ethical Hacker (2024)</div>
            <div>✓ <strong>Cisco:</strong> CyberOps Associate (2024)</div>
            <div>✓ <strong>Cisco:</strong> CCNA Switching, Routing &amp; Wireless (2023)</div>
            <div>✓ <strong>AWS Academy:</strong> Introduction to Cloud Semesters 1 &amp; 2</div>
          </div>
        </section>

        {/* 7. LANGUAGES */}
        <section id="languages" className="cv-card glass-card" style={{ padding: '28px' }}>
          <h2 style={{ color: '#45aaf2', borderBottom: '2px solid rgba(69, 170, 242, 0.3)', paddingBottom: '8px', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaLanguage /> LANGUAGES
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '16px'
          }}>
            <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '16px 20px', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
              <div style={{ color: '#ffffff', fontWeight: '700', fontSize: '1.05rem', marginBottom: '4px' }}>English</div>
              <div style={{ color: '#00d2d3', fontSize: '0.9rem', fontWeight: '500' }}>Native speaker</div>
            </div>
            <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '16px 20px', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
              <div style={{ color: '#ffffff', fontWeight: '700', fontSize: '1.05rem', marginBottom: '4px' }}>Yoruba</div>
              <div style={{ color: '#00d2d3', fontSize: '0.9rem', fontWeight: '500' }}>Mother tongue</div>
            </div>
            <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '16px 20px', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.05)' }}>
              <div style={{ color: '#ffffff', fontWeight: '700', fontSize: '1.05rem', marginBottom: '4px' }}>Finnish</div>
              <div style={{ color: '#00d2d3', fontSize: '0.9rem', fontWeight: '500' }}>B2 Intermediate</div>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
}

export default CV;

